var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMulticotizadorInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#8a8a8a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.9,1.41a.93.93,0,0,0-.8,0L3.65,4.72a1.07,1.07,0,0,0-.65,1v5a11.49,11.49,0,0,0,8.22,11,1.06,1.06,0,0,0,.56,0,11.49,11.49,0,0,0,8.22-11v-5a.94.94,0,0,0-.55-.85Zm6.33,4.47a.43.43,0,0,1,.25.38v4.4a10,10,0,0,1-7,9.53,10,10,0,0,1-7-9.53V6.59a.91.91,0,0,1,.54-.84L11.3,3a.47.47,0,0,1,.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.18,12a2.27,2.27,0,0,0-.9-.66A9.72,9.72,0,0,0,12.2,11V8.56a2.2,2.2,0,0,1,.44.12,4.55,4.55,0,0,1,.89.49,1.08,1.08,0,0,0,.26.14.65.65,0,0,0,.2,0,.44.44,0,0,0,.33-.19.66.66,0,0,0,.15-.42.64.64,0,0,0-.28-.54,3.93,3.93,0,0,0-2-.84V6.65A.62.62,0,0,0,12,6.22a.56.56,0,0,0-.43-.16.54.54,0,0,0-.42.16.58.58,0,0,0-.16.43v.72a3,3,0,0,0-1.74.82,2.1,2.1,0,0,0-.67,1.58A1.81,1.81,0,0,0,9,11a2.41,2.41,0,0,0,.93.68,10.87,10.87,0,0,0,1.1.36V14.4a4.56,4.56,0,0,1-.62-.13,4.46,4.46,0,0,1-1-.5l-.26-.13a.52.52,0,0,0-.21,0,.43.43,0,0,0-.33.18.71.71,0,0,0-.14.43.57.57,0,0,0,.06.31.55.55,0,0,0,.2.23,3.56,3.56,0,0,0,1.07.57,5.42,5.42,0,0,0,1.27.27v.7a.58.58,0,0,0,.16.43.54.54,0,0,0,.42.16.56.56,0,0,0,.43-.16.62.62,0,0,0,.16-.43v-.72a3,3,0,0,0,1.71-.79,2.11,2.11,0,0,0,.64-1.55A1.8,1.8,0,0,0,14.18,12Zm-3.26-1.37a1.61,1.61,0,0,1-.6-.36.79.79,0,0,1-.24-.61,1,1,0,0,1,.42-.86A2.08,2.08,0,0,1,11,8.58v2.11Zm1.75,3.47a2,2,0,0,1-.47.21v-2l.09,0a1.64,1.64,0,0,1,.57.33.68.68,0,0,1,.23.54A1,1,0,0,1,12.67,14.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMulticotizadorInactive);
export default __webpack_public_path__ + "static/media/ic-multicotizador-inactive.fec2f829b920406827e610a0fab6d012.svg";
export { ForwardRef as ReactComponent };